import axios, { Method, AxiosRequestConfig, AxiosError } from 'axios';

export interface ApiRequestOptions {
  method?: Method;
  data?: AxiosRequestConfig['data'];
  headers?: Record<string, string>;
}

export async function apiRequest(url: string, options: ApiRequestOptions = {}) {
  const axiosConfig = {
    method: options.method,
    url: url,
    data: options.data,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    withCredentials: true,
  };

  try {
    const response = await axios(axiosConfig);
    return { success: true, data: response.data, response: response };
  } catch (error: unknown) {
    console.error('API Wrapper request error:', error);
    const axiosError = error as AxiosError;
    return { success: false, error: axiosError?.response?.data || axiosError.message };
  }
}
